import classNames from "classnames";
import React, { ReactNode } from "react";

import { InfoIcon } from "components/Icons";
import CustomTooltip from "components/Tooltip";

import styles from "./FormRow.module.scss";

type Props = {
  required?: boolean;
  label: ReactNode;
  input: ReactNode;
  helperText?: string | React.ReactNode;
  classes?: {
    row?: string;
    label?: string;
    inputContainer?: string;
    tooltip?: string;
  };
};

const FormRow = (props: Props) => {
  const { input, label, required, classes, helperText } = props;
  return (
    <div className={classNames(styles.row, classes?.row)}>
      <div
        className={classNames(styles.label, classes?.label, {
          [styles.required]: required,
        })}
      >
        <span>{label}</span>
        {!!helperText && (
          <CustomTooltip
            title={helperText}
            placement="top"
            classes={{ tooltip: classes?.tooltip }}
          >
            <div className={styles.labelIcon}>
              <InfoIcon />
            </div>
          </CustomTooltip>
        )}
      </div>
      <div
        className={classNames(styles.inputContainer, classes?.inputContainer)}
      >
        {input}
      </div>
    </div>
  );
};

export default FormRow;
